import React, { useEffect, useState } from 'react'
import { Breadcrumbs, GlobalLoader } from '@reactiveonline/reactive_admin_shared-packages'
import GlobalImports from '../shared/GlobalImports'

const initialAccountInformationState = {
  packageName: '...',
  accountStatus: '...',
  storeName: '...',
  superadminEmail: '...',
  superadminName: '...',
  createdAt: '...',
  defaultTenantUrl: null,
  merchantId: '...',
  companyName: '...',
  vatNumber: '...',
  currentOnboardingStep: '...'
}

export default function Show({
  appProps, breadcrumbs, displayCreatorInfo, getAccountInfoPath, icon, registration, updatePath
}) {
  const [accountInformation, setAccountInformation] = useState(initialAccountInformationState)
  const [updateFields, setUpdateFields] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!registration.archivedAt) {
      setLoading(true)

      Rails.ajax({
        type: 'GET',
        url: getAccountInfoPath,
        dataType: 'json',
        success: res => {
          setAccountInformation(prevState => ({ ...prevState, ...res.account }))

          setLoading(false)
          setUpdateFields(true)
        },
        error: _ => {
          setAccountInformation(prevState =>({
            ...prevState,
            accountStatus: registration.filterableFields.find(el => el.key === 'account_status')?.value,
            superadminEmail: registration.filterableFields.find(el => el.key === 'email')?.value,
            companyName: registration.filterableFields.find(el => el.key === 'company_name')?.value,
            vatNumber: registration.filterableFields.find(el => el.key === 'vat_number')?.value,
            currentOnboardingStep: registration.filterableFields.find(el => el.key === 'current_onboarding_step')?.value,
            merchantId: registration.filterableFields.find(el => el.key === 'merchant_id')?.value,
            storeName: registration.filterableFields.find(el => el.key === 'store_name')?.value
          }))

          setLoading(false)
        }
      })
    }
  }, [])

  useEffect(() => {
    if (updateFields) {
      const fd = new FormData()

      fd.append('registration[filterable_fields_attributes][0][id]', registration.filterableFields.find(el => el.key === 'email').id)
      fd.append('registration[filterable_fields_attributes][0][value]', accountInformation.superadminEmail)
      fd.append('registration[filterable_fields_attributes][1][id]', registration.filterableFields.find(el => el.key === 'current_onboarding_step').id)
      fd.append('registration[filterable_fields_attributes][1][value]', accountInformation.currentOnboardingStep)
      fd.append('registration[filterable_fields_attributes][2][id]', registration.filterableFields.find(el => el.key === 'account_status').id)
      fd.append('registration[filterable_fields_attributes][2][value]', accountInformation.accountStatus)
      fd.append('registration[filterable_fields_attributes][3][id]', registration.filterableFields.find(el => el.key === 'company_name').id)
      fd.append('registration[filterable_fields_attributes][3][value]', accountInformation.companyName)
      fd.append('registration[filterable_fields_attributes][4][id]', registration.filterableFields.find(el => el.key === 'vat_number').id)
      fd.append('registration[filterable_fields_attributes][4][value]', accountInformation.vatNumber)
      fd.append('registration[filterable_fields_attributes][5][id]', registration.filterableFields.find(el => el.key === 'store_name').id)
      fd.append('registration[filterable_fields_attributes][5][value]', accountInformation.storeName)

      Rails.ajax({
        type: 'PATCH',
        url: updatePath,
        dataType: 'json',
        data: fd
      })
    }
  }, [updateFields])

  return (
    <>
      <div className='page-wrapper-header'>
        <div>
          <div className='page-header'>
            <i className={ `fa-light ${ icon }` }/>
            <h1 className='page-header-title'>
              { registration.filterableFields.find(el => el.key === 'email').value }
            </h1>
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>
      </div>

      { !!registration.archivedAt &&
        <div
          className="onboarding-notification"
          style={{ backgroundColor: '#a11' }}
        >
          { Partners.translations.tenant.deleted_account }
        </div>
      }

      <div className="card">
        <div className="card-content">
          <div className="card-title">General</div>
          <div className="card-body">
            <table>
              <thead>
                <tr><th></th></tr>
              </thead>
              <tbody>
                <tr>
                  <td>{ Partners.translations.tenant.flavour }</td>
                  <td>
                    { registration.formattedFlavour }
                  </td>
                </tr>
                <tr>
                  <td>{ Partners.translations.tenant.plan }</td>
                  <td>
                    { accountInformation.packageName }
                  </td>
                </tr>
                <tr>
                  <td>{ ReactiveCore.translations.status }:</td>
                  {/* status should be formatted like in directors */}
                  <td>{ accountInformation.accountStatus }</td>
                </tr>
                <tr>
                  <td>{ Partners.translations.columns.currentOnboardingStep }:</td>
                  <td>{ accountInformation.currentOnboardingStep }</td>
                </tr>
                <tr>
                  <td>{ Partners.translations.tenant.store_name }:</td>
                  <td>{ accountInformation.storeName }</td>
                </tr>
                <tr>
                  <td>{ Partners.translations.tenant.superadmin_email }:</td>
                  <td>{ accountInformation.superadminEmail }</td>
                </tr>
                <tr>
                  <td>{ Partners.translations.tenant.superadmin_name }:</td>
                  <td>{ accountInformation.superadminName }</td>
                </tr>
                <tr>
                  <td>{ Partners.translations.columns.companyName }:</td>
                  <td>{ accountInformation.companyName }</td>
                </tr>
                <tr>
                  <td>{ Partners.translations.columns.vatNumber }:</td>
                  <td>{ accountInformation.vatNumber }</td>
                </tr>
                <tr>
                  <td>{ Partners.translations.tenant.merchant_id }:</td>
                  <td>{ accountInformation.merchantId }</td>
                </tr>
                <tr>
                  <td>{ Partners.translations.columns.createdAt }:</td>
                  <td>{ accountInformation.createdAt }</td>
                </tr>

                { displayCreatorInfo &&
                  <>
                    <tr>
                      <td>{ Partners.translations.registration.creator_email }</td>
                      <td>{ registration.createdBy?.email }</td>
                    </tr>
                    <tr>
                      <td>{ Partners.translations.registration.creator_name }</td>
                      <td>{ registration.createdBy?.name }</td>
                    </tr>
                  </>
                }
              </tbody>
            </table>

            { !!accountInformation.defaultTenantUrl &&
              <div className='flex-box items-center content-end m-t-50'>
                <a
                  className='btn'
                  href={ accountInformation.defaultTenantUrl }
                  target='_blank'
                >
                  { Partners.translations.tenant.go_to_website }
                </a>
              </div>
            }
          </div>
        </div>
      </div>

      { loading && <GlobalLoader fullPage /> }
      <GlobalImports appProps={ appProps } />
    </>
  )
}